import type { CSSProperties } from 'react';

/** How far the hole grows at aperture 1 — past the corners of any viewport. */
export const APERTURE_OPEN_RADIUS = '80vmax';
/** Soft edge on a partial iris. Open (aperture 1) is a hard cut. */
export const APERTURE_FEATHER = '2.5vmax';

/**
 * Inverse circle: the overlay stays, the center is punched through.
 * Soft edge so the iris does not read as a hard cookie-cutter.
 */
export const apertureMaskStyle = (
  aperture: number
): CSSProperties | undefined => {
  if (aperture <= 0) {
    return undefined;
  }

  const hole =
    aperture >= 1
      ? APERTURE_OPEN_RADIUS
      : `calc(${aperture} * ${APERTURE_OPEN_RADIUS})`;
  const feather = aperture >= 1 ? '0px' : APERTURE_FEATHER;
  const mask = `radial-gradient(circle at 50% 50%, transparent ${hole}, #000 calc(${hole} + ${feather}))`;

  return {
    maskImage: mask,
    WebkitMaskImage: mask,
  };
};
